import { createFileRoute, Outlet } from "@tanstack/react-router";
import styled from "styled-components";
import Scene from "@/components/three/Scene";
import Sidepanel from "@/components/ui/Sidepanel";
import { useEnvironment } from "@react-three/drei";
import { BREAKPOINTS, ENVIRONMENT_FILE } from "@/globals";
import { useAppStore } from "@/stores/appStore";

export const Route = createFileRoute("/_configurator")({
	loader: () => useEnvironment.clear({ files: ENVIRONMENT_FILE }), // Prevent issues with gainmaps.
	shouldReload: ({ cause }) => (cause === "enter" ? true : false), // Only re-run loader on initial enter.
	component: Configurator,
});

function Configurator() {
	const selectedProduct = useAppStore((state) => state.selectedProduct);

	return (
		<ConfiguratorContainer>
			<Overlay>
				<h1 style={title}>{selectedProduct}</h1>
			</Overlay>
			<Scene />
			<Sidepanel>
				<Outlet />
			</Sidepanel>
		</ConfiguratorContainer>
	);
}

const ConfiguratorContainer = styled.div`
	display: flex;
	width: 100%;
	height: 100svh;

	#three-canvas {
		width: 100%;
		height: 100svh;
	}

	@media (max-width: ${BREAKPOINTS.mobile}px) {
		#three-canvas {
			height: 50vh !important;
		}
	}

	@media (max-width: ${BREAKPOINTS.mobile}px) {
		flex-direction: column;
	}
`;

const Overlay = styled.div`
	width: calc(100vw - 400px);
	height: 100vh;
	position: absolute;
	pointer-events: none;
	z-index: 100;

	& > * {
		pointer-events: all;
	}
`;

const title = {
	fontFamily: "Inter, serif",
	textAlign: "center" as const,
	color: "white",
};
